import { defineComponent as a, createBlock as l, openBlock as r, unref as p, mergeProps as d, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconSoundOn",
  __name: "IconSoundOn",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, n) => (r(), l(p(c), d(t, { "view-box": "0 0 24 24" }), {
      default: u(() => [...n[0] || (n[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M11.954 4.098C12.769 3.425 14 4.004 14 5.062v13.876c0 1.058-1.231 1.638-2.046.964l-3.21-2.652H7.25A3.25 3.25 0 0 1 4 14v-4a3.25 3.25 0 0 1 3.25-3.25h1.493l3.21-2.652M12.5 5.592 9.63 7.964A1.25 1.25 0 0 1 8.832 8.25H7.25A1.75 1.75 0 0 0 5.5 10v4a1.75 1.75 0 0 0 1.75 1.75h1.583a1.25 1.25 0 0 1 .796.286l2.871 2.372V5.592",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M17.157 5.54a.75.75 0 0 1 1.053-.133C20.209 6.957 21.5 9.33 21.5 12s-1.291 5.042-3.29 6.593a.75.75 0 0 1-.92-1.186C18.953 16.117 20 14.17 20 12s-1.047-4.118-2.71-5.407a.75.75 0 0 1-.133-1.053" }, null, -1),
        e("path", { d: "M16.466 8.103a.75.75 0 1 0-.858 1.23A3.245 3.245 0 0 1 17 12a3.245 3.245 0 0 1-1.392 2.667.75.75 0 0 0 .858 1.23A4.745 4.745 0 0 0 18.5 12a4.745 4.745 0 0 0-2.034-3.897" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
